import { FC, ReactNode } from "react";

interface WidgetTooltipProps {
  title: ReactNode;
  subtitle: ReactNode;
  content: ReactNode;
}

export const WidgetTooltip: FC<WidgetTooltipProps> = ({
  title,
  subtitle,
  content,
}) => (
  <div className="box-border w-[160px] min-w-0 rounded-xl bg-white p-3 font-secondary break-words shadow-[0_5px_16px_0_rgba(0,0,0,0.16)]">
    <div className="flex min-w-0 flex-col gap-0.5">
      <div className="min-w-0 text-[15px] font-medium text-dark-800">
        {title}
      </div>
      <div className="min-w-0 text-[13px] leading-[140%] text-grey-900">
        {subtitle}
      </div>
    </div>
    <div className="my-2 h-px w-full bg-dark-100" />
    <div className="min-w-0 break-words">{content}</div>
  </div>
);
